import { useGetPersonByIdQuery } from "@/services/api";
import type { MaybeType } from "@/shared/types";

export const useContactTabsExtra = (selectedPersonId: MaybeType<string>) => {
  const { isFetching } = useGetPersonByIdQuery(
    { id: selectedPersonId ?? "" },
    { skip: !selectedPersonId || selectedPersonId === "TEMP_ID" },
  );

  return {
    state: {
      isFetching,
    },
  };
};
